import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PersonalDetailsModel } from './models/customer.model';

import { BaseHttpService } from '../base-http/base-http.service';
import { TokenService } from '../token/token.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerHttpService extends BaseHttpService {
  private readonly httpClient = inject(HttpClient);

  constructor(tokenService: TokenService) {
    super(tokenService);
  }

  getPersonalDetails(): Observable<PersonalDetailsModel> {
    return this.httpClient.get<PersonalDetailsModel>(
      `${this.baseUrl}api/v${this.apiVersion}/PersonalDetails`,
      { headers: this.customAuthHeaders }
    );
  }

  updateProfile(model?: any): Observable<HttpResponse<any>> {
    model = model ?? { partner: null };
    return this.httpClient.post<any>(
      `${this.updateBaseUrl}2026/api/v${this.apiVersion}/Profile/Update`,
      model,
      { headers: this.customAuthHeaders, observe: 'response' }
    );
  }
}
